import React from "react";
import styled, { css } from "styled-components";
import withTheme from "../styles/withTheme";

const PropTypes = {};
const DefaultProps = {};

const WidgetContainer = styled.div`
  ${props => css`
    border-top: 3px solid ${props.mainVisual};
  `} background: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  padding: 15px;
`;

const Title = styled.h3`
  margin: 0 0 10px 0;
  font-size: 18px;
  color: #666;
`;

export const Widget = props => (
  <WidgetContainer {...props}>
    {props.title && <Title>{props.title}</Title>}
    {props.children}
  </WidgetContainer>
);

Widget.propTypes = PropTypes;
Widget.defaultProps = DefaultProps;

export const mapThemeToProps = theme => {
  return {
    mainVisual: theme.color.mainVisual
  };
};

export default withTheme(mapThemeToProps)(Widget);



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Widget/Widget.js